import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormLabel from "@mui/material/FormLabel";
import { Autocomplete } from "@mui/material";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { useNavigate } from "react-router-dom";
import {
  Checkbox,
  FormControlLabel,
  TextField,
  FormHelperText,
} from "@mui/material";
import { handleSubmitNewDiceAlert } from "./EditCameraUtils/handleSubmitNewDiceAlert";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";

export const AddDiceAlertDialog = ({
  setAddDiceAlertDialogOpen,
  addDiceAlertDialogOpen,
  diceAlerts,
  setBackdropLoadingScreenOn,
  setCameraGeneralInfo,
  setCameraGeneralInfoBackup,
  setGeneralInfoChangesMade,
  setPatchObject,
  setDiceAlerts,
  setActiveTab,
  cameraGeneralInfoBackup,
  setIgnoreZonesBreadCrumbs,
  handleSitesBreadcrumbClick,
  handleSingularSiteBreadcrumbClick,
  cameraGeneralInfo,
  setSendingDiceTest,
  setDiceTestSuccessDialogOpen,
  setDiceTestFailDialogOpen,
  setDeleteDiceAlertDialogOpen,
  sureviewAlerts,
  setAddSureviewAlertDialogOpen,
  cameraWebhookData,
  setAddStreamWebhookDialogOpen,
  setEditStreamWebhookDialogOpen,
  sentinelAlerts,
  setAddSentinelAlertDialogOpen,
  boldAlerts,
  setAddBoldAlertDialogOpen,
  patriotAlerts,
  setAddPatriotAlertDialogOpen,
  softguardAlerts,
  setAddSoftguardAlertDialogOpen,
  diceAlertsOnCamera,
  sureViewAlertsOnCamera,
  siteInfo,
  webhooksAlertsOnCamera,
  sentinelAlertsOnCamera,
  boldAlertsOnCamera,
  patriotAlertsOnCamera,
  softguardAlertsOnCamera,
  evalinkAlertsOnCamera,
}: {
  setAddDiceAlertDialogOpen: any;
  addDiceAlertDialogOpen: any;
  diceAlerts: any;
  setBackdropLoadingScreenOn: any;
  setCameraGeneralInfo: any;
  setCameraGeneralInfoBackup: any;
  setGeneralInfoChangesMade: any;
  setPatchObject: any;
  setDiceAlerts: any;
  setActiveTab: any;
  cameraGeneralInfoBackup: any;
  setIgnoreZonesBreadCrumbs: any;
  handleSitesBreadcrumbClick: any;
  handleSingularSiteBreadcrumbClick: any;
  cameraGeneralInfo: any;
  setSendingDiceTest: Dispatcher<boolean>;
  setDiceTestSuccessDialogOpen: Dispatcher<boolean>;
  setDiceTestFailDialogOpen: Dispatcher<boolean>;
  setDeleteDiceAlertDialogOpen: Dispatcher<boolean>;
  sureviewAlerts: any;
  setAddSureviewAlertDialogOpen: any;
  cameraWebhookData: any;
  setAddStreamWebhookDialogOpen: any;
  setEditStreamWebhookDialogOpen: any;
  sentinelAlerts: any;
  setAddSentinelAlertDialogOpen: any;
  boldAlerts: any;
  setAddBoldAlertDialogOpen: Dispatcher<boolean>;
  patriotAlerts: any;
  setAddPatriotAlertDialogOpen: Dispatcher<boolean>;
  softguardAlerts: any;
  setAddSoftguardAlertDialogOpen: Dispatcher<boolean>;
  diceAlertsOnCamera: any;
  sureViewAlertsOnCamera: any;
  siteInfo: any;
  webhooksAlertsOnCamera: any;
  sentinelAlertsOnCamera: any;
  boldAlertsOnCamera: any;
  patriotAlertsOnCamera: any;
  softguardAlertsOnCamera: any;
  evalinkAlertsOnCamera: boolean;
}) => {
  const { cameraStreams, cameraStreamsPatchObject } = useEditCameraStore();

  const streamNames = new Map();
  cameraStreams?.forEach((object: any, index: number) => {
    streamNames.set(`${object.name} (${object.product})`, index);
  });

  const navigate = useNavigate();

  const [postObject, setPostObject] = React.useState({
    id: -1,
    dice_server: "",
    dice_port: 0,
    dice_email: "",
    dice_input1: "",
    draw_ignore_zones: false,
    active: true,
  });

  const [selectedStreamNames, setSelectedStreamNames] = React.useState<
    string[]
  >([]);

  React.useEffect(() => {
    if (diceAlerts[0]) {
      setPostObject({
        id: -1,
        dice_server: diceAlerts[0].dice_server,
        dice_port: diceAlerts[0].dice_port,
        dice_email: diceAlerts[0].dice_email,
        dice_input1: diceAlerts[0].dice_input1,
        draw_ignore_zones: diceAlerts[0].draw_ignore_zones,
        active: true,
      });
    }
  }, []);

  return (
    <Dialog
      open={addDiceAlertDialogOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Add Dice Alert</DialogTitle>
      <DialogContent>
        {cameraStreams && cameraStreams.length > 1 && (
          <div>
            <FormLabel component="legend" sx={{ paddingBottom: 1 }}>
              {" "}
              Streams*
            </FormLabel>
            <Autocomplete
              multiple
              options={cameraStreams.map((object: any) => {
                return `${object.name} (${object.product})`;
              })}
              sx={{ width: 400 }}
              renderInput={(params) => <TextField {...params} />}
              onChange={(event, value) => {
                setSelectedStreamNames(value);
              }}
            />
            <br></br>
          </div>
        )}
        <TextField
          id="dice_server"
          variant="standard"
          label="Dice Server"
          defaultValue={diceAlerts[0] ? diceAlerts[0].dice_server : ""}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, dice_server: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          helperText="What is the url for your dice server."
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="dice_port"
          variant="standard"
          label="Dice Port"
          defaultValue={diceAlerts[0] ? diceAlerts[0].dice_port : ""}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return {
                ...previousState,
                dice_port: parseInt(event.target.value, 10),
              };
            });
          }}
          sx={{ width: "400px" }}
          helperText="What is the port for your dice server."
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="dice_email"
          variant="standard"
          label="Dice email"
          defaultValue={diceAlerts[0] ? diceAlerts[0].dice_email : ""}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, dice_email: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="dice_input1"
          variant="standard"
          label="Dice Input1"
          defaultValue={diceAlerts[0] ? diceAlerts[0].dice_input1 : ""}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, dice_input1: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <div>
          <FormControlLabel
            sx={{
              fontFamily: "Mulish",
              color: "#001943",
            }}
            label="Draw Ignore Zones"
            control={
              <Checkbox
                color="primary"
                defaultChecked={
                  diceAlerts[0] ? diceAlerts[0].draw_ignore_zones : false
                }
                onChange={(event, checked) => {
                  setPostObject((previousState: any) => {
                    return { ...previousState, draw_ignore_zones: checked };
                  });
                }}
              />
            }
          />
          <FormHelperText>
            If checked, draws ignore zones in the alert images.
          </FormHelperText>
        </div>
      </DialogContent>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setAddDiceAlertDialogOpen(false);
          }}
          text="Cancel"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            const selectedStreamIndexs: number[] = [];

            const streamsObjectToPost = JSON.parse(
              JSON.stringify(cameraStreamsPatchObject)
            );

            if (cameraStreams && cameraStreams.length > 1) {
              selectedStreamNames.forEach((streamName: string) => {
                selectedStreamIndexs.push(streamNames.get(streamName));
              });

              selectedStreamIndexs.forEach((streamIndex: number) => {
                if (streamsObjectToPost[streamIndex]) {
                  streamsObjectToPost[streamIndex].dice_alerts = [
                    ...streamsObjectToPost[streamIndex].dice_alerts,
                    postObject,
                  ];
                }
              });
            }

            if (cameraStreams && cameraStreams.length === 1) {
              streamsObjectToPost[0].dice_alerts.push(postObject);
            }

            setAddDiceAlertDialogOpen(false);
            setBackdropLoadingScreenOn(true);
            handleSubmitNewDiceAlert(
              cameraGeneralInfo,
              diceAlerts,
              streamsObjectToPost,
              navigate,
              setBackdropLoadingScreenOn,
              setCameraGeneralInfo,
              setCameraGeneralInfoBackup,
              setGeneralInfoChangesMade,
              setPatchObject,
              setDiceAlerts,
              setActiveTab,
              setAddDiceAlertDialogOpen,
              cameraGeneralInfoBackup,
              setIgnoreZonesBreadCrumbs,
              handleSitesBreadcrumbClick,
              handleSingularSiteBreadcrumbClick,
              setSendingDiceTest,
              setDiceTestSuccessDialogOpen,
              setDiceTestFailDialogOpen,
              setDeleteDiceAlertDialogOpen,
              sureviewAlerts,
              setAddSureviewAlertDialogOpen,
              cameraWebhookData,
              setAddStreamWebhookDialogOpen,
              setEditStreamWebhookDialogOpen,
              sentinelAlerts,
              setAddSentinelAlertDialogOpen,
              boldAlerts,
              setAddBoldAlertDialogOpen,
              patriotAlerts,
              setAddPatriotAlertDialogOpen,
              softguardAlerts,
              setAddSoftguardAlertDialogOpen,
              diceAlertsOnCamera,
              sureViewAlertsOnCamera,
              siteInfo,
              webhooksAlertsOnCamera,
              sentinelAlertsOnCamera,
              boldAlertsOnCamera,
              patriotAlertsOnCamera,
              softguardAlertsOnCamera,
              evalinkAlertsOnCamera
            );
          }}
          text="Submit"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
